import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import {  EpaApi } from '../../../services'
import { IAppliance } from '../../../types'
import { AppliancesState } from '../appliances.slice'

export const fetchAppliancesAsync = createAsyncThunk(
  'applications/fetch',
  async (options: AxiosRequestConfig, { rejectWithValue }) => {
    try {

      const response = await EpaApi.getAppliances(options);
      return (response as AxiosResponse<IAppliance[]>).data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || 'Failed to fetch appliances');
    }
  }
);

export const fetchAppliancesDetailsAsyncBuilder = (
  builder: ActionReducerMapBuilder<AppliancesState>
) => {
  builder
  .addCase( fetchAppliancesAsync.pending, (state) => {
    state.loading = true;
    state.error = null;
  })
  .addCase( fetchAppliancesAsync.fulfilled, (state, action) => {
    state.loading = false;
    state.data = action.payload;
  })
  .addCase( fetchAppliancesAsync.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload as string;
  });
};